import { compose } from "ramda";
import Component from "./components";
import connect from "./containers/connect.js";
import withState from './containers/withState';

export default compose(
    connect,
    withState,
)(Component)